var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGloboEscritura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m46 120c-24.851562 0-46 20.148438-46 45v210c0 24.851562 21.148438 45 46 45h15v77c0 6.0625 3.648438 11.542969 9.257812 13.855469 1.859376.777343 3.808594 1.144531 5.742188 1.144531 3.894531 0 7.734375-1.523438 10.605469-4.394531l86.605469-87.605469h173.789062c24.851562 0 45-20.148438 45-45v-210c0-24.851562-20.148438-45-45-45zm0 0",
    fill: "#4bb9ec"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m197 330h-91c-8.289062 0-15-6.710938-15-15s6.710938-15 15-15h91c8.289062 0 15 6.710938 15 15s-6.710938 15-15 15zm0 0",
    fill: "#575f64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m293.652344 281.140625c-.636719.632813-1.273438 1.269531-1.910156 1.480469l-88.460938 46.035156c-6.148438 2.757812-12.511719 1.0625-16.757812-3.179688-4.242188-4.242187-5.9375-10.609374-3.179688-16.757812l46.035156-88.460938c.210938-.636718.847656-1.273437 1.484375-1.90625l50.910157 11.875 4.453124 1.0625zm0 0",
    fill: "#ffcebf"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m507.546875 68.09375-31.820313 31.820312-52.398437-11.242187-1.484375-.210937-9.757812-52.1875 31.820312-31.820313c5.9375-5.9375 15.273438-5.9375 21.210938 0l42.425781 42.429687c5.941406 5.9375 5.941406 15.273438.003906 21.210938zm0 0",
    fill: "#7c8388"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m286.226562 231.289062 7.425782 49.851563c-.636719.632813-1.273438 1.269531-1.910156 1.480469l-88.460938 46.035156c-6.148438 2.757812-12.511719 1.0625-16.757812-3.179688l95.25-95.25zm0 0",
    fill: "#ffb99c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m507.546875 68.09375-31.820313 31.820312-52.398437-11.242187 63.003906-63.003906 21.214844 21.214843c5.9375 5.9375 5.9375 15.273438 0 21.210938zm0 0",
    fill: "#575f64"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m475.726562 99.914062-179.742187 179.738282c-.636719.636718-1.484375 1.0625-2.332031 1.488281l-62.789063-62.792969c.421875-.847656.847657-1.695312 1.484375-2.332031l179.738282-179.742187zm0 0",
    fill: "#ff641a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m475.726562 99.914062-179.742187 179.738282c-.636719.636718-1.484375 1.0625-2.332031 1.488281l-31.394532-31.398437 181.648438-181.648438zm0 0",
    fill: "#f03800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGloboEscritura);
export default __webpack_public_path__ + "static/media/globo_escritura.f80d12b75fb5f7a77526c83c9d5c4376.svg";
export { ForwardRef as ReactComponent };